/**
 * 平台: fusion端webview
 * 通用能力:
 * 1.bridge fusionBridge
 * 2.登录: hitchappLogin | hitchappIsLogin
 * 3.定位: hitchappLocate
 * 4.订阅: None
 * 5.分享: None
 */
import { utils, payFormatParams } from '@didi/webx-js-core';
import FusionClass from '@didi/fusion';
import { storage } from '../../../storage';
import { xenv as getXenv } from '../../../xenv';
import { getPayParams, passengerFormat } from '../../../pay/payParams';
import { PassengerJump } from './goTo';
function commonJump(loadParams, xenv, commonParams = {}) {
    new PassengerJump(loadParams, xenv, commonParams).doJump();
}
function initCallMethod(bridge) {
    bridge.call = function (FnName, params, callback) {
        if (typeof FnName !== 'string') {
            console.error('bridge.call FnName必须使用string类型， 传入FnName: ', FnName);
            return;
        }
        if (FnName in bridge) {
            bridge[FnName](params, callback);
        }
        else {
            console.error(`bridge.call 不存在"${FnName}"方法`);
        }
    };
}
let hitchappBridge = new FusionClass(['DidiBridgeAdapter', 'TraceModule']);
if (hitchappBridge)
    initCallMethod(hitchappBridge);
const hitchappLocate = (option = {}) => {
    return new Promise((resolve, reject) => {
        const finalOption = getXenv() === 'kfpassenger' ? option : {};
        hitchappBridge.getLocationInfo(finalOption, function (res) {
            if (res && (res.lat || res.lng || res.cityId || res.city_id)) {
                /* 获取定位信息成功 存入缓存 */
                storage.locationInfo = {
                    lat: Number(res.lat || 0),
                    lng: Number(res.lng || 0),
                    cityId: Number(res.cityId || 0) || Number(res.city_id || 0),
                    area: String(res.area || '')
                };
                let newRiskParams = Object.assign({}, storage.riskParams, { latitude: res.lat, longitude: res.lng, cityId: res.cityId || res.city_id });
                utils.cleanEmptyKey(newRiskParams);
                storage.riskParams = newRiskParams;
                resolve({
                    lat: Number(res.lat || 0),
                    lng: Number(res.lng || 0),
                    cityId: Number(res.cityId || 0) || Number(res.city_id || 0),
                    area: String(res.area || '')
                });
            }
            else {
                /* 获取定位信息失败 存入缓存 */
                storage.locationInfo = {};
                let newRiskParams = Object.assign({}, storage.riskParams, { latitude: undefined, longitude: undefined, cityId: undefined });
                utils.cleanEmptyKey(newRiskParams);
                storage.riskParams = newRiskParams;
                reject({});
            }
        });
    });
};
const hitchappIsLogin = (option, callback) => {
    return new Promise((resolve, reject) => {
        hitchappBridge.getUserInfo({}, res => {
            const { useQuick } = option || {};
            if (res && res.phone) {
                const userInfo = {
                    token: res.token || res.ticket,
                    phone: res.phone,
                    uid: res.uid
                };
                /* 获取用户信息成功 存入缓存 */
                storage.userInfo = { ...userInfo };
                let newRiskParams = Object.assign({}, storage.riskParams, { newTicket: res.token || res.ticket });
                utils.cleanEmptyKey(newRiskParams);
                storage.riskParams = newRiskParams;
                /* 执行传入cb */
                useQuick && callback && callback({ ...userInfo });
                resolve({ ...userInfo });
            }
            else {
                /* 获取用户信息失败 存入缓存 */
                storage.userInfo = {};
                let newRiskParams = Object.assign({}, storage.riskParams, { newTicket: undefined });
                utils.cleanEmptyKey(newRiskParams);
                storage.riskParams = newRiskParams;
                reject({});
            }
        });
    });
};
const hitchappLogin = () => {
    return new Promise((resolve, reject) => {
        hitchappIsLogin().then(resolve, () => {
            hitchappBridge.requestLogin({}, res => {
                if (res && (res.userInfo.token || res.userInfo.ticket) && res.userInfo.phone) {
                    /* 获取用户信息成功 存入缓存 */
                    storage.userInfo = {
                        phone: res.userInfo.phone,
                        token: res.userInfo.token,
                        uid: res.userInfo.uid
                    };
                    let newRiskParams = Object.assign({}, storage.riskParams, { newTicket: res.token || res.ticket });
                    utils.cleanEmptyKey(newRiskParams);
                    storage.riskParams = newRiskParams;
                    resolve({
                        phone: res.userInfo.phone,
                        token: res.userInfo.token,
                        uid: res.userInfo.uid
                    });
                }
                else {
                    /* 获取用户信息失败 存入缓存 */
                    storage.userInfo = {};
                    let newRiskParams = Object.assign({}, storage.riskParams, { newTicket: undefined });
                    utils.cleanEmptyKey(newRiskParams);
                    storage.riskParams = newRiskParams;
                    reject({
                        extraInfo: {
                            login_result: res.login_result
                        }
                    });
                }
            });
        });
    });
};
const hitchappSetLoginConfig = () => { };
const hitchappSetShare = (option) => {
    /* 这里是通过setShare收集到的分享动作完成后的回调 */
    /* TODO: 涉及添加多个参数来接收回调 之前K是放在config里 不放在config里则会多出N个参数 */
    // window.__showEntranceCallBack__ = function (ret) {
    //   // ret
    //   // share_result: Number  // -1：需要授权，0：成功，1：失败，2：取消
    //   // channel: String // wechat
    //   if (typeof ret === 'string') {
    //     try {
    //       ret = JSON.parse(ret)
    //     } catch (e) {
    //       ret = {}
    //     }
    //   }
    //   if (ret.share_result === 0) {
    //     if (config.success) config.success(ret)
    //   } else if (ret.share_result === 2) {
    //     if (config.cancel) config.cancel(ret)
    //   } else {
    //     if (config.fail) config.fail(ret)
    //   }
    // }
    hitchappBridge.initEntrance(option);
    hitchappBridge.showEntrance(option);
};
const getChannel = (option) => {
    return option && option.channel;
};
const hitchappInvokeShare = (option) => {
    if ('buttons' in option) {
        /* 多渠道invokeShare 拉起面板 */
        hitchappBridge.initEntrance(option);
        hitchappBridge.invokeEntrance(option);
    }
    else if ('channel' in option) {
        /* 单渠道分享 取config中channel作为目标渠道 */
        const method = getChannel(option);
        if (method in hitchappBridge) {
            hitchappBridge[method](option);
        }
    }
};
const hitchappPay = (params) => {
    if (typeof params === 'string') {
        params = {
            options: {
                out_trade_id: params
            }
        };
    }
    let { pay, options, out_trade_id, token, ...args } = params;
    /* 增加埋点 */
    try {
        window.PerfTrack.customTrack('$_use_pay_is_new', {
            is_new: options ? 1 : 0,
        });
        // eslint-disable-next-line no-empty
    }
    catch (_) { }
    const passengerPrograms = getPayParams('passenger');
    const payInfo = utils.merge({}, passengerPrograms, {
        options: options || pay || {
            out_trade_id: out_trade_id,
            token: token,
        },
        ...args
    });
    const paramsFormat = payFormatParams(passengerFormat, payInfo);
    return new Promise((resolve, reject) => {
        hitchappBridge.openUniPay(paramsFormat.options, function (res) {
            if (res.code === 1) {
                resolve(res);
            }
            else {
                reject(res);
            }
        });
    });
};
const hitchappSaveImg = (url) => {
    return new Promise((resolve, reject) => {
        hitchappBridge.saveImage({
            type: 'image',
            image: url
        }, res => {
            if (+res.share_result === 0) {
                resolve(res);
            }
            else {
                reject(res);
            }
        });
    });
};
const hitchappGetSystemInfo = () => {
    return new Promise((resolve) => {
        hitchappBridge.getSystemInfo({}, (res) => {
            const result = {
                ...res,
                ddfp: res.ddfp || res.imei
            };
            delete result.imei;
            resolve(result);
        });
    });
};
export { hitchappBridge, hitchappIsLogin, hitchappLogin, hitchappSetLoginConfig, hitchappLocate, hitchappSetShare, hitchappInvokeShare, hitchappPay, hitchappSaveImg, hitchappGetSystemInfo, commonJump as hitchappCommonJump };
